export default {
    moves: '移動',
    time: '時間',
    score: 'スコア',
    settings: '設定',
    sounds: 'サウンド',
    autocomplete: 'オートコンプリート',
    leftHanded: '左利きモード',
    newDeal: '新しいゲーム',
    design: 'カスタマイズ',
    easy: '初級',
    medium: '中級',
    hard: '上級',
    expert: 'エキスパート',
    master: 'マスター',
    random: 'ランダム',
    balanced: 'バランス',
    rulesKlondikeURL: 'https://solitaires.com/jp/articles/how-to-play-solitaire/',
    cardHighlight: 'カードの強調表示',
    rulesSpiderURL: 'https://solitaires.com/jp/articles/how-to-play-spider-solitaire/',
    rulesFreecellURL: 'https://solitaires.com/jp/articles/how-to-play-freecell-solitaire/',
    autoPlay: 'オートプレイ',
    noMagicNeeded: '魔法の杖は不要—自分でゲームを続行しよう！',
    leaveFeedback: 'フィードバックをどうぞ',
    feedbackThankYou: 'ご感想ありがとうございます！',
    feedbackError: 'エラーが発生しました。メッセージが送信されませんでした。',
    thanksSubscribing: 'ご購読ありがとうございます！',
    rulesPyramidURL: 'https://solitaires.com/jp/articles/how-to-play-pyramid-solitaire/',

    tutorialSkip: 'スキップ',
    tutorialRestart: '最初からやり直す',

    klondikeTutorialStep1: 'すべてのカードを土台に移動するのが目標です。各スートを<span style="color: #F11F1F;">A♥、2♥、3♥</span>のように、エースからキングまで順番に並べましょう。カードをタップして移動させてください！',
    klondikeTutorialStep2: '素晴らしい！引き続き土台にカードを並べましょう。',
    klondikeTutorialStep3: 'よくできました！列の間でカードを移動できます。移動するには、1つ上のランクで色が違うカードの上に置いてください。',
    klondikeTutorialStep4: '一番下のカードが1つランクが低く、色が異なる場合は、シーケンスを移動できます。',
    klondikeTutorialStep5: '場に空の列がある場合は、キングまたはキングから始まる並びのみ置くことができます。',
    klondikeTutorialStep6: '動かせるカードがなくなったら、山札をタップして新しいカードをめくりましょう。カードは場か土台に置けます。',
    klondikeTutorialStep7: 'いいですね！ここからは自分でプレイしてみましょう。',
    klondikeTutorialStep8: '山札がなくなったら、タップしてリフレッシュし、ゲームを続けよう。',
    klondikeTutorialStep9: 'あと少し！土台の山を完成させて勝利を目指しましょう。',

    spiderTutorialStep1: 'すべてのカードを場にキングからエースまで降順に並べて、ファウンデーションに移動するのが目的です。カードをタップしてシーケンスを作り始めましょう！',
    spiderTutorialStep2: '一番下のカードが置く先のカードよりも1つ小さい場合、シーケンス全体を動かすことができます。下のカードをタップしてすべてを移動しましょう！',
    spiderTutorialStep3: 'よくできました！シーケンスを完成させると、自動的にファウンデーションに移動します。',
    spiderTutorialStep4: '動かせるカードがなくなったら、山札をタップして新しいカードを配りましょう。各列に1枚ずつ配られます。',
    spiderTutorialStep5: '素晴らしい！ここからは自分でゲームを進めましょう！',

    freeCellTutorialStep1: 'すべてのカードを土台に移動するのが目標です。各スートをA♠、2♠、3♠のように、エースからキングまで順番に並べましょう。カードをタップして送ってください！',
    freeCellTutorialStep2: '場の列の間でカードを移動できます。1つ上のランクで色が異なるカードの上に置いてください。',
    freeCellTutorialStep3: '一番下のカードが1つランクが低くて、置こうとしているカードと色が異なれば、その並びを移動できます。覚えておいてください：移動できるカードの数は、空いているフリーセルの数＋1 を超えることはできません。',
    freeCellTutorialStep4: '場に空の列があれば、どのカードでも1枚または並びを置くことができます。',
    freeCellTutorialStep5: 'フリーセルはカードを一時的に保管できる特別なスペースです。各セルには1枚のカードを置けて、必要に応じて場や土台に戻せます。',
    freeCellTutorialStep6: 'ここからはあなたの番です！覚えたことを使ってゲームを完成させましょう！',

    startTutorialPopupTitle: 'ようこそ！この短いチュートリアルでプレイを始める前に基本を学びましょう。',
    startTutorial: 'チュートリアル開始',
    skipTutorial: 'スキップ',
};
